/**
 * ¿Este valor de GA4 (una fuente o un medio) parece tráfico de Meta?
 *
 * Lo usa el autocompletar del editor de filtros para mostrar primero, en una cuenta de Meta, los
 * valores de Meta: cada agencia los nombra a su manera (`facebook`, `Facebook_Instagram`, `fb`, `ig`,
 * `fbig`, `meta`, `l.facebook.com`) y entre los 50 más usados de la propiedad pueden quedar abajo de
 * google, direct y organic.
 *
 * Por palabras y no por substring, para que `digital` no cuente como Instagram: una palabra cuenta si
 * contiene facebook o instagram, o si empieza con fb, ig o meta (`fbig`, `meta_ads`, `igshopping`).
 * Sólo ordena: un falso positivo sube un valor en la lista, nunca lo elige.
 */
const WORD_SEPARATOR = /[^a-z0-9]+/;
const CONTAINED = ['facebook', 'instagram'];
const PREFIXES = ['fb', 'ig', 'meta'];

export function isMetaLikeValue(value) {
    return String(value || '').toLowerCase().split(WORD_SEPARATOR).some(word =>
        CONTAINED.some(part => word.includes(part)) || PREFIXES.some(prefix => word.startsWith(prefix)));
}

/** Los valores de Meta primero, sin perder el orden de uso dentro de cada grupo. */
export function metaFirst(values) {
    const meta = [];
    const rest = [];
    values.forEach(value => (isMetaLikeValue(value.value) ? meta : rest).push(value));
    return [...meta, ...rest];
}
